import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import styles from './styles';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class DropDown extends React.Component {
    constructor(props) {
        super(props)

        this.targetRef = React.createRef();
        this.targetElement = null;
    }

    componentDidMount() {
        this.targetElement = this.targetRef.current;
    }

    componentWillUnmount() {

        clearAllBodyScrollLocks();
    }

    render() {
        const { classes, ...other } = this.props;
        return (
            <Select ref={this.targetRef}
                className={classes.dropDown}
                fullWidth
                margin="none"
                variant="filled"
                input={<OutlinedInput labelWidth={0} className={this.dropDown} {...this.props.inputProps} />}
                onOpen={this.onOpen}
                onClose={this.onClose}
                {...other}>
                {this.props.children}
            </Select>
        );
    }

    onOpen = (event) => {
        disableBodyScroll(this.targetElement);
    }

    onClose = (event) => {
        enableBodyScroll(this.targetElement);
    }
}

DropDown.propTypes = {
    classes: PropTypes.object
}

export default withStyles(styles)(DropDown);